<template>
  <div
    id="google-pay"
    class="google-pay-button"
    data-testid="gpay-btn"
    @click="gPayClicked"
  >
    <CNuxtImg
      class="google-pay-button__loading-icon"
      src="data:image/svg+xml;base64,PHN2ZyBjbGFzcz0ic3ZnLWxvYWRlciIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iNTUiIGhlaWdodD0iNTUiIHZpZXdCb3g9IjAgMCA4MCA4MCI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTQwIDcyQzIyLjQgNzIgOCA1Ny42IDggNDBTMjIuNCA4IDQwIDhzMzIgMTQuNCAzMiAzMmMwIDEuMS0uOSAyLTIgMnMtMi0uOS0yLTJjMC0xNS40LTEyLjYtMjgtMjgtMjhTMTIgMjQuNiAxMiA0MHMxMi42IDI4IDI4IDI4YzEuMSAwIDIgLjkgMiAycy0uOSAyLTIgMnoiPjxhbmltYXRlVHJhbnNmb3JtIGF0dHJpYnV0ZVR5cGU9InhtbCIgYXR0cmlidXRlTmFtZT0idHJhbnNmb3JtIiB0eXBlPSJyb3RhdGUiIGZyb209IjAgNDAgNDAiIHRvPSIzNjAgNDAgNDAiIGR1cj0iMC42cyIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiLz48L3BhdGg+PC9zdmc+"
      alt="loader"
      min-height="57px"
    />
  </div>
</template>

<script setup lang="ts">
import { useGPay } from '~/composables/gPay.ts';

interface GPayProps {
  amount: number
  roundedPrice: number
  chargebeeId: string
  upsale?: boolean
  isDisabled?: boolean
  requestPayerEmail?: boolean
}

const props = withDefaults(defineProps<GPayProps>(), {
  upsale: false,
  isDisabled: false,
  requestPayerEmail: false,
});

const emits = defineEmits(['success', 'toggle-loader', 'action', 'update-component']);

const { gPayClicked, contentLoading, mountGooglePayButton, clearPaymentIntent } = useGPay({
  roundedPrice: toRef(props, 'roundedPrice'),
  chargebeeId: toRef(props, 'chargebeeId'),
  upsale: toRef(props, 'upsale'),
  isDisabled: toRef(props, 'isDisabled'),
  requestPayerEmail: toRef(props, 'requestPayerEmail'),
  onSuccess: (paymentIntentId: string) => emits('success', paymentIntentId),
  onToggleLoader: () => emits('toggle-loader'),
  onAction: () => emits('action'),
  onUpdateComponent: () => emits('update-component'),
});

defineExpose({ gPayClicked, contentLoading, mountGooglePayButton, clearPaymentIntent });
</script>

<style scoped lang="scss">
.google-pay-button {
  width: 100%;
  height: 57px;
  position: relative;
  background: $black-button;
  border-radius: 9px;

  &__loading-icon {
    max-width: 30px;
    max-height: 30px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
